export default __webpack_public_path__ + "static/media/img_cloud2.cbe5ca68.png";